// extracted by mini-css-extract-plugin
module.exports = {"appLogo":"AppLogo_appLogo__3yd9Z"};